import ClientsContainer from "@/features/clients/containers/clients-container";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/clients/")({
  component: ClientsContainer,
});
